import { useTranslation } from 'react-i18next';
import { HMI_TABS } from 'features/hmi/hmi.utils';
import { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs';

export const breadcrumbTranslation = (path: string) => () => {
  const { t } = useTranslation();
  const translation = t(`breadCrumbs.${path}`);
  const hasTranslation = !translation.startsWith('breadCrumbs');
  return hasTranslation ? translation : path;
};

export const getHmiTabBreadcrumb =
  (prefix: string) =>
  ({ match }: BreadcrumbComponentProps<'tab'>) => {
    const tab = match.params.tab || 'overview';
    const isKnownTab = HMI_TABS.some(({ key }) => key === tab);
    return breadcrumbTranslation(isKnownTab ? `${prefix}-${tab}` : prefix)();
  };
